import * as API from '../api/RnrsApi';
import { RnrsData } from '../components/rnrs/RnrsBulkUploadPreview';

export function getAllRnrs(lastEvaluatedKeyData) {
  return API.getAllRnrs(lastEvaluatedKeyData);
}

export function createReviewResponse(productId, userId, response) {
  return API.createReviewResponse(productId, userId, response);
}

export function updateReviewResponse(productId, userId, response) {
  return API.updateReviewResponse(productId, userId, response);
}

export function deleteReviewResponse(productId, userId) {
  return API.deleteReviewResponse(productId, userId);
}

export function changeReviewVisibility(productId, userId, hidden) {
  return API.changeReviewVisibility(productId, userId, hidden);
}

export function updateRnRFeaturedStatus(item) {
  return API.updateRnRFeaturedStatus(item);
}

export function batchCreateRnrs(data: RnrsData) {
  return API.batchCreateRnrs(data);
}
